import { Button, Form, FormInstance, Input, Popconfirm } from 'antd';
import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { ImagePreview } from '../ImagePreview';
import { InsertMedia } from '../InsertMedia';

import {
  AnswerWrapper,
  StyledFormItem,
  StyledRadio,
  Wrapper,
  FormulaWrapper
} from './Answer.styles';

import { Icon } from '@/components/Icon';

type Props = {
  name: number;
  correctAnswer: number;
  handleCorrectAnswer: (name: number) => void;
  remove: (index: number | number[]) => void;
  form: FormInstance;
};

export const Answer: FC<Props> = ({ name, correctAnswer, handleCorrectAnswer, remove, form }) => {
  const { t } = useTranslation(['DefaultTranslations', 'CommonQuizFormTranslations']);
  const isDisabled = name === 0 || name === correctAnswer;
  const isChecked = name === correctAnswer;
  const answer = Form.useWatch(['answers', name], form);

  return (
    <Fragment>
      <AnswerWrapper>
        <StyledRadio checked={isChecked} onChange={() => handleCorrectAnswer(name)} />
        <StyledFormItem
          name={[name, 'text']}
          rules={[{ required: true, message: t('DefaultTranslations:REQUIRED_FIELD') }]}>
          <Input placeholder={t('CommonQuizFormTranslations:WRITE_HERE_THE_ANSWER')} />
        </StyledFormItem>
        <InsertMedia answerIndex={name} form={form} />
        <Popconfirm
          placement="left"
          disabled={isDisabled}
          onConfirm={() => remove(name)}
          title={t('CommonQuizFormTranslations:ARE_YOU_SURE_TO_DELETE_ANSWER')}>
          <Button type="link" disabled={isDisabled} icon={<Icon i="TrashCan" />} />
        </Popconfirm>
      </AnswerWrapper>
      <Wrapper>
        <Form.Item noStyle name={[name, 'formula']}>
          {answer?.formula && (
            <FormulaWrapper dangerouslySetInnerHTML={{ __html: answer?.formula }} />
          )}
        </Form.Item>
      </Wrapper>
      <Form.Item noStyle name={[name, 'file']}>
        <ImagePreview />
      </Form.Item>
    </Fragment>
  );
};
